import React,  { Component } from 'react'
import ContentBlock from '../ContentBlock'

class DekstopEmbed extends Component {

    render() {
        const { bgImage, embedCode } = this.props 

        return (
            <ContentBlock className="content-block content-block--fullscreen content-block--fluid content-block--secondary">
                <picture className="content-block__bg-image" ref="image">
                    {/* <source media="(max-width:800px)" srcSet={project.small_image} /> */}
                    <img src={bgImage} width="710" height="500" alt="Background image" />
                </picture>
                <div className="c-notebook-emulator">
                    <div className="c-notebook-emulator__screen" dangerouslySetInnerHTML={{__html: embedCode }}></div>
                </div>            
            </ContentBlock>
        )
    }

}

export default DekstopEmbed


// WEBPACK FOOTER //
// ./src/components/Demo/DesktopEmbed.js